// Redux
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Services
import { boardService } from '../services/boardService';

const fetchBoards = createAsyncThunk('board/fetchBoards', async () => {
  const response = await boardService.getBoards();
  return response;
});

const createBoard = createAsyncThunk('board/createBoard', async ({ name, emoji }) => {
  const response = await boardService.createBoard(name, emoji);
  return response;
});

const updateBoard = createAsyncThunk('board/updateBoard', async ({ numBoard, name, isActive, emoji }) => {
  const response = await boardService.updateBoard(numBoard, name, isActive, emoji);
  return response;
});

const boardSlice = createSlice({
  name: 'board',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Boards
      .addCase(fetchBoards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBoards.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchBoards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create Board
      .addCase(createBoard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createBoard.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(createBoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Update Board
      .addCase(updateBoard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBoard.fulfilled, (state, action) => {
        state.loading = false;
        // Remove da lista se ficou inativo (delete lógico)
        if (!action.payload.isActive) {
          state.list = state.list.filter(b => b.numBoard !== action.payload.numBoard);
        } else {
          const index = state.list.findIndex(b => b.numBoard === action.payload.numBoard);
          if (index !== -1) state.list[index] = action.payload;
        }
      })
      .addCase(updateBoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export default boardSlice.reducer;
export { fetchBoards, createBoard, updateBoard };